// extracted by mini-css-extract-plugin
export default {"root":"root--yq_kE","row":"row--Q2A8s"};